import React, { FunctionComponent } from 'react';
import { AppointmentType } from './AppointmentList';

interface Props {
  onChange: (property: string, val: string) => void;
  property: string;
  appointmentType: AppointmentType;
  value: string;
}

const getAppointmentWindowOptions = () =>
  ['15', '30', '60'].map(i => (
    <option key={i} value={i}>
      {i} mins
    </option>
  ));

export const AppointmentWindow: FunctionComponent<Props> = ({
  onChange,
  property,
  appointmentType,
  value,
}) => (
  <div className="input-container input-select-container">
    <label>Appointment Window</label>
    <select
      className="prodigy-select"
      onChange={e => onChange(property, e.target.value)}
      id={`${appointmentType}-appointment-window`}
      name={`${appointmentType}-appointment-window`}
      value={value || '60'}
    >
      {getAppointmentWindowOptions()}
    </select>
  </div>
);
